import { render } from "./VerificationPrompt.vue?vue&type=template&id=add60710&scoped=true"
import script from "./VerificationPrompt.vue?vue&type=script&lang=ts"
export * from "./VerificationPrompt.vue?vue&type=script&lang=ts"

import "./VerificationPrompt.vue?vue&type=style&index=0&id=add60710&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-add60710"

export default script